<div
  class="vimeo-wrapper"
  [ngClass]="{
    'drawer-open': isGalleryDrawerOpen,
  }"
>
  <div class="vimeo-embed-wrapper">
    <div id="vimeo-player" class="vimeo-player"></div>
    <div class="vimeo-embed-controls" [ngClass]="{ 'participants-control': !isPresenter }">
      @if (isPresenter) {
        <div class="button-group-wrapper w-full">
          <button
            type="button"
            class="vimeo-embed-control"
            [matTooltip]="playing ? 'Pause' : 'Play'"
            (click)="requestPlayMedia(!playing)"
            (touchend)="requestPlayMedia(!playing)"
          >
            @if (!playing) {
              <mat-icon>play_arrow</mat-icon>
            }
            @if (playing) {
              <mat-icon>pause</mat-icon>
            }
          </button>
          <button
            type="button"
            class="vimeo-embed-control"
            matTooltip="Restart"
            (click)="requestChangeTime(0)"
            (touchend)="requestChangeTime(0)"
          >
            <mat-icon>refresh</mat-icon>
          </button>
          <div class="vimeo-embed-control embed-progress">
            {{ formatedVideoTime(currentVideoTime) }}
            <input
              type="range"
              name="embed-progress"
              id="embed-progress"
              min="0"
              max="{{ videoTime }}"
              [value]="currentVideoTime"
              (input)="requestChangeTime($any($event.target).value)"
            />
            {{ formatedVideoTime(videoTime) }}
          </div>
        </div>
      }
      <div class="button-group-wrapper">
        <!-- TODO - try another approach because PiP needs an interaction with the IFrame in order to work -->
        <!-- <button matTooltip="Picture in Picture" type="button" class="vimeo-embed-control" (click)="requestPiP()">
        <mat-icon>picture_in_picture</mat-icon>
      </button> -->
        <button matTooltip="Fullscreen" type="button" class="vimeo-embed-control" (click)="requestFullScreen()">
          <mat-icon>fullscreen</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
